import firstImage from 'App/assets/tutorialLinkEmployees/1.png';
import secondImage from 'App/assets/tutorialLinkEmployees/2.png';
import thirdImage from 'App/assets/tutorialLinkEmployees/3.png';
import fourthImage from 'App/assets/tutorialLinkEmployees/4.png';

export const tutorialLinkEmployeesSteps = [
	{
		title: 'Obtén el formato de registro',
		description:
			'Para dar de alta a los colaboradores descarga el archivo con el formato para registrar colaboradores.',
		img: {
			src: firstImage,
			width: 240,
			heigth: 240,
		},
	},
	{
		title: 'Llena cuidadosamente el formato',
		subtitle:
			'Dentro del formato, llena la columna ‘PERFIL_RIESGO’ y/o ‘AREA_EXPOSICION’ con el nombre correspondiente',
		description: `Importante: Ingresa el nombre ya sea de un Perfil de Riesgo o Área de Exposición tal cual como están nombrados, de lo contrario los colaboradores no se vincularán correctamente.`,
		img: {
			src: secondImage,
			width: 280,
			heigth: 200,
		},
	},
	{
		title: 'Completa el formato',
		description:
			'Termina de llenar el documento que descargaste con la información de los colaboradores que vas a vincular; recuerda verificar que la información es correcta.',
		img: {
			src: thirdImage,
			width: 240,
			heigth: 240,
		},
	},
	{
		title: 'Sube el archivo',
		description:
			'Una vez que hayas llenado el documento, súbelo a la plataforma',
		img: {
			src: fourthImage,
			width: 240,
			heigth: 240,
		},
	},
];
